import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostBreakdownFetchFailedAction = {
	type: 'AI_COST_BREAKDOWN_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostBreakdownFetchFailedAction => ({
	type: 'AI_COST_BREAKDOWN_FETCH_FAILED',
	payload,
});
